import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71')
];

export const server_loads = [];

export const dictionary = {
		"/[[lang=locale]]/(index-page)": [12,[2],[3]],
		"/[[lang=locale]]/(non-auth)/accept-invite": [60,[2],[3]],
		"/[[lang=locale]]/(need-unauth)/account-recovery": [53,[2,11],[3]],
		"/contract-review/preview": [71],
		"/[[lang=locale]]/error": [70,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign": [61,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign/auth": [62,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign/exit": [63,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign/view": [64,[2],[3]],
		"/[[lang=locale]]/(non-auth)/like-reload": [65,[2],[3]],
		"/[[lang=locale]]/(non-auth)/login/sso/[ssoPartnerType]": [66,[2],[3]],
		"/[[lang=locale]]/(non-auth)/logout": [67,[2],[3]],
		"/[[lang=locale]]/(need-unauth)/reset-password-from-email": [54,[2,11],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-in": [55,[2,11],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/email-input": [56,[2,11],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/set-password": [57,[2,11],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/user-name": [58,[2,11],[3]],
		"/[[lang=locale]]/(non-auth)/sign-up/invite": [68,[2],[3]],
		"/[[lang=locale]]/(non-auth)/sso-sign-in-callback": [69,[2],[3]],
		"/[[lang=locale]]/(need-unauth)/sso-sign-up-callback": [59,[2,11],[3]],
		"/[[lang=locale]]/(need-auth)/welcome": [52,[2,4],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]": [13,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/account/profile": [29,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/ask-ai": [14,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/calendar": [15,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-draft": [16,[2,4,5,6,7],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-draft/agent": [17,[2,4,5,6,7],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-draft/import": [18,[2,4,5,6,7],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-review": [19,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/documents": [20,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/drafts": [21,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign": [22,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/bulk-sends/[externalId]": [23,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk": [43,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk/confirm": [44,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk/prepare": [45,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk/recipients": [46,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/bulk/upload": [47,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new": [48,[2,4,5,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new/prepare": [49,[2,4,5,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new/signers": [50,[2,4,5,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new/upload": [51,[2,4,5,10],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/send": [24,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/send/bulk": [25,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/send/contracts": [26,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/home": [27,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/members": [30,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/search": [28,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings": [31,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/account": [32,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/apps": [33,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/billing": [34,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/company": [35,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/contract-types": [36,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/members": [37,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/notifications": [38,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/plan": [39,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/plan/checkout": [40,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/plan/credit-checkout": [41,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/usage": [42,[2,4,5,8],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';